import React from 'react';
import { useState, useEffect } from 'react';

import t from '../Translation/Translation';

import Button from 'react-bootstrap/Button';
import { Form, FloatingLabel, Row, Col } from 'react-bootstrap';

import { logD } from '../Util/Util';
import conf from '../../config.json';

export default function Upload(props) {
    logD('Drafts.Upload', props);
    const selected = props.selected;

    const [type, setType] = useState(1);
    const types = [
        {value: 1, text: t('output_exp')},
        {value: 2, text: t('output_ne')},
        {value: 3, text: t('report')},
    ];

    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new FormData(e.target);
        //const data = Object.fromEntries(formData.entries());
        formData.append('idBl', selected.idBrandlift);
        formData.append('type', type);

        //data['idBl'] = selected.idBrandlift;
        //data['type'] = type;

        console.log(formData);
        fetch(conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/uploadBlFile', {
            method: 'POST',
            headers: {
              'authorization': 'Bearer ' + props.token
            },
            //body: new URLSearchParams(data),
            body: formData,
        })
        .then(props.handleError)
        .then(data => {
            props.handleFinish();
        });
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col>
                    <FloatingLabel className="mb-3" controlId="types" label={t('type_file')}>
                        <Form.Select name="types"
                            value={type}
                            onChange={e => {
                            console.log("e.target.value", e.target.value);
                            setType(e.target.value);
                            }}>
                            {
                                types.map(function(is) {
                                    return <option key={is.value} 
                                                value={is.value}
                                                className="optionType"
                                                >{is.text}</option>
                                })
                            }
                        </Form.Select>
                    </FloatingLabel>
                    <Form.Label htmlFor="file">{t('file')}</Form.Label>
                    <Form.Group className="mb-3" controlId="file">
                        <Form.Control type="file" name="file" />
                    </Form.Group>
                </Col>
            </Row>
            <Button type="submit">Submit</Button>
        </Form>
    );
};